import { render } from "./RefundDetails.vue?vue&type=template&id=0add30a8&scoped=true"
import script from "./RefundDetails.vue?vue&type=script&lang=js"
export * from "./RefundDetails.vue?vue&type=script&lang=js"

import "./RefundDetails.vue?vue&type=style&index=0&id=0add30a8&lang=css"
import "./RefundDetails.vue?vue&type=style&index=1&id=0add30a8&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0add30a8"]])

export default __exports__